export default __webpack_public_path__ + "static/media/image_1.15dd6bf4.jpg";